module.exports = __webpack_public_path__ + "img/listing-flyer.a6257a25.png";